module.exports = __webpack_public_path__ + "img/3_img.d4f762e8.png";